(function () {
  if (window.__pilipinasUpsellClicksV11) return;
  window.__pilipinasUpsellClicksV11 = true;

  const rootOf = (node) => node && node.closest('cart-upsell, [data-cart-upsell]');
  const cardsOf = (root) => Array.from(root.querySelectorAll('[data-upsell-card]'));

  const show = (root, index) => {
    const cards = cardsOf(root);
    if (!cards.length) return;
    const next = ((index % cards.length) + cards.length) % cards.length;
    root.dataset.upsellIndex = String(next);
    cards.forEach((card, i) => {
      const on = i === next;
      card.classList.toggle('is-active', on);
      card.toggleAttribute('hidden', !on);
    });
  };

  const clearLoading = () => {
    document.querySelectorAll('#cart-drawer [loading], #cart-drawer .loading, cart-items-component[loading]').forEach((el) => {
      el.removeAttribute('loading');
      el.classList.remove('loading', 'cart-items-disabled');
    });
  };

  const syncHeaderCart = (count) => {
    const n = Number(count) || 0;
    document.querySelectorAll('#cart-drawer [data-cart-count]').forEach((el) => {
      el.textContent = String(n);
    });
    document.querySelectorAll('cart-icon .cart-bubble, .header-actions__cart-icon .cart-bubble').forEach((bubble) => {
      const countEl = bubble.querySelector('.cart-bubble__text-count');
      if (countEl) countEl.textContent = String(n);
      bubble.classList.toggle('visually-hidden', n === 0);
      if (countEl) countEl.classList.toggle('hidden', n === 0);
    });
  };


  const syncUpsell = (cart) => {
    const upsell = document.querySelector('#cart-drawer cart-upsell, cart-upsell');
    if (!upsell) return;
    const total = Number(cart.total_price) || 0;
    if (upsell.dataset.upsellMode === 'sticker60') {
      // $60+ sticker add-on: keep it at $60+, drop it under $60 or once a sticker is in the cart.
      const hasSticker = (cart.items || []).some((item) =>
        /sticker/i.test(String(item.product_title || '') + ' ' + String(item.product_type || ''))
      );
      if (total < 6000 || hasSticker) {
        upsell.remove();
        return;
      }
    } else if (total >= 6000) {
      upsell.remove();
      return;
    }
    const inCart = new Set((cart.items || []).map((item) => Number(item.product_id)));
    cardsOf(upsell).forEach((card) => {
      const id = Number(card.getAttribute('data-product-id'));
      if (inCart.has(id)) card.remove();
    });
    const left = cardsOf(upsell);
    if (!left.length) {
      upsell.remove();
      return;
    }
    upsell.hidden = false;
    show(upsell, 0);
  };

  const refreshDrawer = async () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(root + '?section_id=cart-drawer-section', {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    });
    if (!res.ok) throw new Error('section fetch failed');
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

    const swap = (selector) => {
      const next = doc.querySelector(selector);
      const live = document.querySelector(selector);
      if (next && live) live.innerHTML = next.innerHTML;
    };

    swap('#cart-drawer .cart-items__wrapper');
    swap('#cart-drawer .cart__checkout-button .button-text');
    swap('#cart-drawer .cart-totals__installments');

    const nextUpsell = doc.querySelector('#cart-drawer cart-upsell, cart-upsell');
    const liveUpsells = document.querySelectorAll('#cart-drawer cart-upsell, cart-upsell');
    if (nextUpsell && liveUpsells.length) {
      liveUpsells[0].replaceWith(nextUpsell);
      document.querySelectorAll('#cart-drawer cart-upsell, cart-upsell').forEach((node, i) => {
        if (i > 0) node.remove();
      });
    } else {
      liveUpsells.forEach((node) => node.remove());
    }

    const nextBar = doc.querySelector('#cart-drawer free-shipping-bar, free-shipping-bar');
    const liveBar = document.querySelector('#cart-drawer free-shipping-bar');
    if (liveBar) {
      if (nextBar) {
        liveBar.innerHTML = nextBar.innerHTML;
        // Copy state too (class, data, hidden), not just the message.
        ['class', 'data-total', 'data-item-count', 'data-ship-us'].forEach((name) => {
          const value = nextBar.getAttribute(name);
          if (value === null) liveBar.removeAttribute(name);
          else liveBar.setAttribute(name, value);
        });
        liveBar.toggleAttribute('hidden', nextBar.hasAttribute('hidden'));
      } else {
        // Empty cart: the server renders no bar, so hide the stale one.
        liveBar.classList.add('fsb--empty');
        liveBar.setAttribute('hidden', '');
      }
    }

    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
    syncHeaderCart(cart.item_count);
    syncUpsell(cart);
    keepSummaryUpsell();
    clearLoading();
  };

  const refreshInstallments = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?section_id=cart-drawer-section', {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    })
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('#cart-drawer .cart-totals__installments');
        const live = document.querySelector('#cart-drawer .cart-totals__installments');
        if (next && live) live.innerHTML = next.innerHTML;
      })
      .catch(() => {});
  };

  let refreshTimer = 0;
  const scheduleRefresh = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      refreshDrawer().catch(() => {});
    }, 60);
  };

  const keepSummaryUpsell = () => {
    document.querySelectorAll('#cart-drawer cart-upsell, cart-upsell').forEach((node) => {
      if (!node.closest('.cart-drawer__summary')) node.remove();
    });
    document.querySelectorAll('#cart-drawer .cart-drawer__summary cart-upsell').forEach((node, i) => {
      if (i > 0) node.remove();
    });
  };

  keepSummaryUpsell();
  document.addEventListener('cart:update', scheduleRefresh);
  document.addEventListener('cart:updated', scheduleRefresh);

  document.addEventListener('click', async (event) => {
    const prev = event.target.closest('[data-upsell-prev]');
    const next = event.target.closest('[data-upsell-next]');
    const add = event.target.closest('[data-upsell-add]');
    if (!prev && !next && !add) return;

    const root = rootOf(event.target);
    if (!root) return;
    event.preventDefault();
    event.stopPropagation();

    const current = Number(root.dataset.upsellIndex || 0);
    if (prev) return show(root, current - 1);
    if (next) return show(root, current + 1);

    const card = add.closest('[data-upsell-card]');
    const select = card && card.querySelector('[data-upsell-variant]');
    const id = select && select.value;
    if (!id) return;

    add.disabled = true;
    add.textContent = 'Adding';
    add.classList.remove('is-error');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: Number(id), quantity: 1 }),
      });
      if (!res.ok) throw new Error('add failed');
      await refreshDrawer();
      add.textContent = 'Added';
      add.disabled = false;
      setTimeout(() => {
        add.textContent = 'Add';
      }, 1200);
    } catch (err) {
      clearLoading();
      add.disabled = false;
      add.textContent = 'Add';
      add.classList.add('is-error');
    }
  });
})();